import { getEncodedParams } from 'helpers/encodeParams';

exports.timeOfDayHeatMapEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/ttd/timeofday/heatmap?start=${encodedParams.start}&end=${encodedParams.end}`;
};

exports.sitesSummaryEndpoint = (state, params) => {
    const encodedParams = getEncodedParams(state);
    return `${state.config.apiUrl}/v1/entity/${params.entityId}/ttd/sitessummary?start=${encodedParams.start}&end=${encodedParams.end}&tactic=${params.channel}`;
};



// WEBPACK FOOTER //
// ./src/services/ttd/selectors.js